import { useToken } from '@/store'
// 根据token缓存
export default (fn: any, set: any): any => {
  let cache: any = null
  let req: any = null
  let token = ''
  return () => {
    if (cache && token === useToken()) return Promise.resolve(cache)
    if (req) return req
    return (req = fn().then((res: any) => {
      cache = set(res)
      token = useToken()
      req = null
      return res
    }))
  }
}

// 定时更新
